module.exports = __webpack_public_path__ + "assets/media/evening.f0e2c16f.mp3";